import _define_property from "@swc/helpers/src/_define_property.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SvgIcon } from "@cinch-labs/design-system";
import classNames from "classnames";
import cx from "classnames";
import Image from "next/image";
import { Primary } from "../buttons/primary/primary";
import { Text } from "../text/text";
import styles from "./full-width-cta.module.css";
export var FullWidthCTA = function(param) {
    var iconName = param.iconName, iconColor = param.iconColor, iconGradient = param.iconGradient, iconSize = param.iconSize, title = param.title, subtitle = param.subtitle, buttonLabel = param.buttonLabel, onButtonClick = param.onButtonClick, img = param.img, className = param.className;
    var innerClassNames = classNames(styles.inner, _define_property({}, styles.innerButtonRight, !img));
    return /*#__PURE__*/ _jsx("section", {
        className: cx(styles.fullWidthCta, className),
        children: /*#__PURE__*/ _jsxs("div", {
            className: innerClassNames,
            children: [
                iconName && /*#__PURE__*/ _jsx(SvgIcon, {
                    name: iconName,
                    size: iconSize,
                    color: iconColor ? iconColor : undefined,
                    gradient: iconGradient ? iconGradient : undefined,
                    className: styles.svg
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.content,
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            children: [
                                /*#__PURE__*/ _jsx(Text, {
                                    className: styles.subtitle,
                                    children: subtitle
                                }),
                                /*#__PURE__*/ _jsx(Text, {
                                    className: styles.title,
                                    children: title
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Primary, {
                            element: "a",
                            onClick: onButtonClick,
                            className: styles.button,
                            children: buttonLabel
                        })
                    ]
                }),
                img && /*#__PURE__*/ _jsx("div", {
                    className: styles.img,
                    children: /*#__PURE__*/ _jsx(Image, {
                        src: img.src,
                        alt: img.alt,
                        width: img.width,
                        height: img.height,
                        layout: "intrinsic"
                    })
                })
            ]
        })
    });
};
